
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gcxAGsDdhl2Su_450eNLN6uWYbU_zvdZ_45FeghAUUNTVOlgMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexc61crJ_cA84xWwP1cQv8GAfrZ1ez68ymBeHzV3x8_45rIMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchHIifk9p9PRJz67Ki1fHh5X5MyOsmjIAGnrgJu0RUhowMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexyVXdRBnPFIHb1faBcUqObz9c8zcSp_e8rxaLwloRNBwMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Timo2Rr_45ab7G7c7VyV9MOldAJX6wx08u5VOD1VRQxTUMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexPHSMOH_bV4KypfQB3Wy8QX_T2MhQG0BSeCdVWS__45yskMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93E4VxblbI2ZFJDM_WFyVGP1r0D5OfxDJ7tnk__455gMbV8Meta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexym5sQCK_45qixZLTvYai5qr_45rl746UVAaqeOTFKHdSqmwMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93pLQGe7dikiOZgG7xWNolaLHFlUdrID6Go62RcfV3ztAMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index5nVCAvkfDmbsvdJTolZX3EqN0OaKKca8abvglmnpIDwMeta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexZLxpA2PUMoj_45DQoc_bGdvD7sEsUOXZbLmGnGropUn78Meta } from "/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexPHSMOH_bV4KypfQB3Wy8QX_T2MhQG0BSeCdVWS__45yskMeta || {},
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexym5sQCK_45qixZLTvYai5qr_45rl746UVAaqeOTFKHdSqmwMeta || {},
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index5nVCAvkfDmbsvdJTolZX3EqN0OaKKca8abvglmnpIDwMeta || {},
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexZLxpA2PUMoj_45DQoc_bGdvD7sEsUOXZbLmGnGropUn78Meta || {},
    component: () => import("/codebuild/output/src565313775/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]